import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogTitle,
  MatDialogClose,
} from '@angular/material/dialog';
import { TagModel } from '../../api/models';
import { DialogReturnType } from '../../app.types';
import { AbstractEditComponent } from 'src/app/cms/common/abstract-edit.component';
import { TagsService } from '../../api/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ContentSpinnerComponent } from '../common/ui/content-spinner.component';
import { NgTemplateOutlet } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormInputComponent } from '../common/form-field/input.component';
import { ButtonComponent } from '../../shared/components/button/button.component';

@Component({
  selector: 'qa-tag-edit',
  templateUrl: './tag-edit.component.html',
  styleUrls: ['./tag-edit.component.scss'],
  imports: [
    ContentSpinnerComponent,
    FormsModule,
    ReactiveFormsModule,
    NgTemplateOutlet,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    FormInputComponent,
    ButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class TagEditComponent extends AbstractEditComponent implements OnInit {
  loading = true;

  constructor(
    @Optional()
    public dialogRef: MatDialogRef<
      TagEditComponent,
      DialogReturnType<TagModel>
    >,
    @Optional() @Inject(MAT_DIALOG_DATA) public input: TagModel,
    private tags: TagsService,
    private matSnackBar: MatSnackBar,
    private translator: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.dialogRef.updateSize('600px');
    const tag: TagModel = this.input;
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl(),
      name: new UntypedFormControl('', Validators.required),
    });
    this.form.reset();
    this.form.patchValue(tag);
    this.loading = false;
  }

  onSubmit(): void {
    this.loading = true;
    const tag: TagModel = this.form.getRawValue();
    this.tags
      .updateUserTags({
        body: tag,
      })
      .subscribe({
        next: () => {
          this.form.markAsUntouched();
          this.form.markAsPristine();
          if (tag.id) {
            this.matSnackBar.open(
              this.translator.instant('tag.message.tagSaved')
            );
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.matSnackBar.open(
            this.translator.instant('tag.message.tagNotSaved')
          );
        },
      });
  }
}
